// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M19.0203 24L21 21.9988L16.2122 17.1591L14.2324 19.1603M5.68175 6.38675H10.5959V14.3205L3 21.9988L4.97972 24L13.4041 15.4843V6.38675H18.3183L12 0\" fill=\"currentColor\"/> </svg> ";
// Exports
module.exports = code;